<template>
  <div class="my-coupon-list">
    <div v-for="(item, index) in list" :key="index">
      <div class="item">
        <img src="@/assets/img/coupon_bg.png" v-if="ctype=='0'" class="img_bg"  @click="goPage(index)"/>
        <img src="@/assets/picture/already.png" v-if="ctype=='1'" class="img_bg" />
        <img src="@/assets/picture/nouse.png" v-if="ctype=='2'" class="img_bg"  />
        <div class="price">
          <div class="box">
            <p class="p"><span class="fz28"></span>{{item.viewPrice}}</p>
            <p class="t">{{item.fullLimit}}</p>
          </div>
        </div>
        <div class="text">
          <p class="tit">{{item.privilegeName}}</p>
          <p class="date">{{item.startTime}}-{{item.failureTime}}</p>
          <!-- <p class="s">{{item.scopeOfUse}}</p> -->
        </div>
        <div class="action" v-if="item.explanationList.length>0">
          <div class="arrow pll30 up" ref="card" @click.stop="actionTab(index)">
            <span>使用说明</span><i></i>
          </div>
        </div>
      </div>
      <div class="item-desc" ref="desc" style="display: none">
        <p class="txt" v-for="(item, pindex) in item.explanationList" :key="pindex">{{(pindex+1) + '. ' + item}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    ctype: {
      type: String,
      default: '0'
    }
  },
  mounted(){
  },
  methods: {
    goPage(index) {
      this.$emit('toPay', index)
      this.$emit('toSelf',index)
    },
    actionTab(i) {
      if (this.$refs.desc[i].style.display=="none") {
        this.$refs.desc[i].style.display="block"
        this.$refs.card[i].setAttribute("class", "arrow pll30 dow");
      }else if (this.$refs.desc[i].style.display=="block") {
        this.$refs.desc[i].style.display="none"
        this.$refs.card[i].setAttribute("class", "arrow pll30 up");
      }

      // :class="$refs[index][0].style.display=='none'?'dow':'up'"
    }
  }
}
</script>

<style lang="less" scoped>
.my-coupon-list {
  padding-top: .1rem;
  .item {
    position: relative;
    line-height: 0;
    margin: auto 0;
    .img_bg {
      width: 100%;
      display:block;
    }
    .price {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      position: absolute;
      width:240px;
      height:200px;
      top: 24px;
      left: 20px;
      display: table;
      .box {
        display: table-cell;
        text-align: center;
        .p {
          font-size:36px;
          font-family:DINAlternate;
          font-weight:bold;
          color:rgba(255,255,255,1);
          line-height:64px;
          padding-top: 24px;
        }
        .t {
          font-size:24px;
          font-family:PingFangSC;
          font-weight:500;
          color:rgba(255,255,255,1);
          line-height:24px;
          padding-top: 10px;
        }
      }
    }
    .text {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      position: absolute;
      top: 24px;
      left: 300px;
      .tit {
        font-size:28px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:32px;
        padding-top: 15px;
      }
      .date, .s {
        font-size:20px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(204,204,204,1);
        line-height:36px;
      }
    }
    .action {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      position: absolute;
      right: 75px;
      bottom: 68px;
      .arrow {
        font-size: .2rem;
        color:#2D2D2D;
        border-bottom: 0;
        text-align: center;
        position: relative;
        border: none;
      }
      .dow i {
        position: absolute;
        top: -2px;
        right: -25px;
        border: 8px solid #2D2D2D;
        border-top-color: #2D2D2D;
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
      }
      .up i {
        position: absolute;
        bottom: -2.8px;
        right: -25px;
        border: 8px solid #2D2D2D;
        border-top-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
      }
    }
  }
}
p {
    display: block;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.item-desc {
  background-color: #fff;
  position: relative;
  top: -30px;
  z-index: -1;
  margin: 0 20px;
  padding: 20px 0;
  .txt {
    padding: 0 28px;
    font-size: 24px;
    color: #999999;
  }
}
</style>
